import React, { useEffect, useState } from "react";
import { Text, View, Image } from "react-native";
import { store } from "../../store/store";

import { getImagePath, isChemistStoreLoaded } from "../../utils/services/CommonUtils";

import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";

import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";
import AppTheme from "../../AppTheme";

const RewardsScreen = (props) => {

    const chemistStoreLoaded = isChemistStoreLoaded()

    const [walletDetails, setWalletDetails] = useState({})

    const earnSS = {
        title: 'How can I earn Sehat Sikke?',
        description: 'You earn Sehat Sikke when you place order for medicines from the website. '
    }
    const useSS = {
        title: 'Where can I use Sehat Sikke?',
        description: 'Sehat Sikke can be used to get discounts on your medicine orders.'
    }

    useEffect(() => {
        const reduxState = store.getState()
        setWalletDetails(reduxState.walletDetails)

    }, [])

    return (
        <View>

            <CommonHeader title={'Rewards'} navigation={props.navigation} />

            <View style={{
                marginTop: AppTheme.headerHeight,
                paddingVertical: 24, paddingHorizontal: 16
            }}>

                <View style={[AppStyles.borderView, {
                    paddingTop: 16, paddingBottom: 18, paddingHorizontal: 16,
                    backgroundColor: AppTheme.color.orange.bg,
                    borderColor: AppTheme.color.orange.border
                }]}>
                    <View style={[AppStyles.flexRowSpaceBetween]}>
                        <Text style={[TextStyle.text16b,
                        { color: AppTheme.color.orange.text }]}>
                            Sehat Sikke</Text>
                        <View style={[AppStyles.flexRowCenter,
                        {
                            paddingHorizontal: 18, paddingVertical: 6,
                            backgroundColor: AppTheme.color.white,
                            borderRadius: 12
                        }]}>
                            <Image style={{ width: 22, height: 22 }}
                                source={{ uri: getImagePath('/images/icons/ss_coin.svg') }} />
                            <Text style={[TextStyle.text24b, { marginLeft: 4 }]}>
                                {walletDetails['balance'] * walletDetails['inrToSSRate']}</Text>
                        </View>
                    </View>
                    <Text style={[TextStyle.text14b, TextStyle.colorGrey, { marginTop: 30 }]}>
                        {walletDetails['inrToSSRate']} Sehat Sikke = ₹1</Text>
                    <Text style={[TextStyle.text12, TextStyle.colorGrey, AppStyles.mt4]}>
                        Validity: 1 Month from the date of credit</Text>
                </View>

                {chemistStoreLoaded ? null : <View style={[AppStyles.borderView,
                AppStyles.bgWhite, AppStyles.p16, AppStyles.mt24]}>
                    <Text style={[TextStyle.text16b]}>{earnSS.title}</Text>
                    <Text style={[TextStyle.text12, TextStyle.flexWrap, AppStyles.mt12]}>
                        {earnSS.description}</Text>
                </View>}

                <View style={[AppStyles.borderView, AppStyles.bgWhite, AppStyles.p16, AppStyles.mt24]}>
                    <Text style={[TextStyle.text16b]}>{useSS.title}</Text>
                    <Text style={[TextStyle.text12, TextStyle.flexWrap, AppStyles.mt12]}>
                        {useSS.description}</Text>
                </View>

            </View>

        </View>
    )
}

export default RewardsScreen